import { TOUR_TRANSLATIONS } from "../translations"

export const getSosKpiSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="sos-kpi-filters"]',
            title: t.sosKpiFilters.title,
            content: t.sosKpiFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="sos-kpi-table"]',
            title: t.sosKpiTable.title,
            content: t.sosKpiTable.content,
        },
        {
            target: '[data-tour="sos-kpi-details"]',
            title: t.sosKpiDetails.title,
            content: t.sosKpiDetails.content,
            data: {
                triggerSequence: [
                    { selector: '[data-tour-kpi-ball]', delay: 400 },
                    { text: 'Split by keyword', delay: 1000 },
                ],
            },
        },
    ]
}
